import { lazy } from "react";

export const CoverageWizardInfoPage = lazy(() =>
  import("./CoverageWizard/CoverageWizardInfoPage").then(module => ({
    default: module.CoverageWizardInfoPage,
  }))
);

export const CoverageWizardLandingPage = lazy(() =>
  import("./CoverageWizard/CoverageWizardLandingPage").then(module => ({
    default: module.CoverageWizardLandingPage,
  }))
);

export const CoverageWizardOptionsPage = lazy(() =>
  import("./CoverageWizard/CoverageWizardOptionsPage").then(module => ({
    default: module.CoverageWizardOptionsPage,
  }))
);

export const CSRLandingPage = lazy(() =>
  import("./CSRLandingPage").then(module => ({
    default: module.CSRLandingPage,
  }))
);

export const DrugSearchPreferencesPage = lazy(() =>
  import("./DrugSearchPreferencesPage").then(module => ({
    default: module.DrugSearchPreferencesPage,
  }))
);

export const EnrollmentFormPage = lazy(() =>
  import("./EnrollmentFormPage").then(module => ({
    default: module.EnrollmentFormPage,
  }))
);

export const FindPlansNowPage = lazy(() =>
  import("./FindPlansNowPage").then(module => ({
    default: module.FindPlansNowPage,
  }))
);

export const InNetworkPharmaciesPage = lazy(() =>
  import("./SelectPharmaciesPage/InNetworkPharmaciesPage").then(module => ({
    default: module.InNetworkPharmaciesPage,
  }))
);

export const LandingPage = lazy(() =>
  import("./LandingPage").then(module => ({
    default: module.LandingPage,
  }))
);

export const LISQuestionsPage = lazy(() =>
  import("./LISQuestionsPage").then(module => ({
    default: module.LISQuestionsPage,
  }))
);

export const LoadingPage = lazy(() =>
  import("./LoadingPage").then(module => ({
    default: module.LoadingPage,
  }))
);

export const LogoutPage = lazy(() =>
  import("./LogoutPage").then(module => ({
    default: module.LogoutPage,
  }))
);

export const MaintenancePage = lazy(() =>
  import("../components/MaintenancePage").then(module => ({
    default: module.MaintenancePage,
  }))
);

export const ManagePharmaciesPage = lazy(() =>
  import("./ManagePharmaciesPage").then(module => ({
    default: module.ManagePharmaciesPage,
  }))
);

export const ManagePrescriptionsPage = lazy(() =>
  import("./ManagePrescriptionsPage").then(module => ({
    default: module.ManagePrescriptionsPage,
  }))
);

export const MedigapLandingPage = lazy(() =>
  import("./Medigap/MedigapLandingPage").then(module => ({
    default: module.MedigapLandingPage,
  }))
);

export const MedigapPlanDetailsPage = lazy(() =>
  import("./Medigap/MedigapPlanDetailsPage").then(module => ({
    default: module.MedigapPlanDetailsPage,
  }))
);

export const MedigapPlans = lazy(() =>
  import("./Medigap/Plans/MedigapPlans").then(module => ({
    default: module.MedigapPlans,
  }))
);

export const MedigapPoliciesPage = lazy(() =>
  import("./Medigap/Policies/MedigapPoliciesPage").then(module => ({
    default: module.MedigapPoliciesPage,
  }))
);

export const NewToMedicarePage = lazy(() =>
  import("./NewToMedicarePage").then(module => ({
    default: module.NewToMedicarePage,
  }))
);

export const PaceLandingPage = lazy(() =>
  import("./Pace/PaceLandingPage").then(module => ({
    default: module.PaceLandingPage,
  }))
);

export const PacePlansPage = lazy(() =>
  import("./Pace/PacePlansPage").then(module => ({
    default: module.PacePlansPage,
  }))
);

export const PapLandingPage = lazy(() =>
  import("./PAP/PapLandingPage").then(module => ({
    default: module.PapLandingPage,
  }))
);

export const PapPlansPage = lazy(() =>
  import("./PAP/PapPlansPage").then(module => ({
    default: module.PapPlansPage,
  }))
);

export const PDEPage = lazy(() =>
  import("./PDEPage/PDEPage").then(module => ({ default: module.PDEPage }))
);

export const PlanComparePage = lazy(() =>
  import("./PlanComparePage").then(module => ({
    default: module.PlanComparePage,
  }))
);

export const PlanDetailsPage = lazy(() =>
  import("./PlanDetailsPage").then(module => ({
    default: module.PlanDetailsPage,
  }))
);

export const PlanPreviewPage = lazy(() =>
  import("./PlanPreviewPage").then(module => ({
    default: module.PlanPreviewPage,
  }))
);

export const QuestionRoutingPage = lazy(() =>
  import("./QuestionRoutingPage").then(module => ({
    default: module.QuestionRoutingPage,
  }))
);

export const SanctionedPlansPage = lazy(() =>
  import("./SanctionedPlansPage").then(module => ({
    default: module.SanctionedPlansPage,
  }))
);

export const SearchResultsPage = lazy(() =>
  import("./SearchResultsPage").then(module => ({
    default: module.SearchResultsPage,
  }))
);

export const SelectPharmaciesPage = lazy(() =>
  import("./SelectPharmaciesPage").then(module => ({
    default: module.SelectPharmaciesPage,
  }))
);

export const SpapLandingPage = lazy(() =>
  import("./SPAP/SpapLandingPage").then(module => ({
    default: module.SpapLandingPage,
  }))
);

export const SpapPlansPage = lazy(() =>
  import("./SPAP/SpapPlansPage").then(module => ({
    default: module.SpapPlansPage,
  }))
);

export const SummaryPage = lazy(() =>
  import("./SummaryPage").then(module => ({ default: module.SummaryPage }))
);

export const VersionPage = lazy(() =>
  import("./VersionPage").then(module => ({ default: module.VersionPage }))
);

export const CSRGuestAccessPage = lazy(() =>
  import("./CSRGuestAccessPage").then(module => ({
    default: module.CSRGuestAccessPage,
  }))
);
